var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('MasterDetail',{attrs:{"baseRoute":"/setup/technicians"},scopedSlots:_vm._u([{key:"list",fn:function(ref){
var state = ref.state;
var selectedId = ref.selectedId;
var selectRow = ref.selectRow;
return [_c('List',{staticClass:"maxh-full-2",attrs:{"state":state,"focusRowId":selectedId},on:{"rowSelected":function (v) { return selectRow(v); }}})]}},{key:"detail",fn:function(ref){
var selectedId = ref.selectedId;
var selectRow = ref.selectRow;
return [(selectedId != null)?_c('div',[_c('Home',{attrs:{"techId":selectedId},on:{"close":function($event){return selectRow(null)}}})],1):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }